import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { Typography } from '@material-ui/core'
import { clearStore } from 'reducers/myJobsDataViewer/action'
import FilterBar from './FilterBar'
import TableData from './TableData'
import InitFilterData from './FilterBar/InitFilterData'
import './style.scss'

class MyJobsDataViewer extends Component {
  componentWillUnmount() {
    this.props.clearStore()
  }

  render() {
    const { isPanelOpen } = this.props

    return (
      <div
        className={cn('module jobs-viewer-module', {
          'open-filters': isPanelOpen,
        })}>
        <div className="module-head">
          <Typography className="module-title" variant="h5">
            {this.props.currentApp.name}
          </Typography>
          <div className="module-filter">
            <FilterBar isPanelOpen={isPanelOpen} />
            <InitFilterData />
          </div>
        </div>
        <div className={cn('module-content')}>
          <TableData isStateCriteria isPanelOpen={isPanelOpen} />
        </div>
      </div>
    )
  }
}

export default connect(
  store => ({
    isPanelOpen: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'filterPanelOpen',
    ]),
  }),
  {
    clearStore,
  },
)(MyJobsDataViewer)
